import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { of } from "rxjs";
import { map, catchError, switchMap } from "rxjs/operators";
import { KioskService, SysParamService } from "src/app/api/services";
import { AppState } from "src/app/state/app.state";
import { keepAlive, keepAliveFailure, keepAliveSuccess, loadSysparams, loadSysparamsFailure, loadSysparamsSuccess, setCardIdMaxAttempt, setHomeS4AddChecksum, setMaxNbSendMailMedicalForm, setPrintLightEnabled, setStopProcessInterval } from "./kiosk.actions";

@Injectable()
export class KioskEffects {
	constructor(private actions$: Actions, private kioskService: KioskService, private sysParamService: SysParamService, private store: Store<AppState>) { }

	public identification$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(keepAlive),
			switchMap(({ kioskId }) =>
				this.kioskService.kioskKeepAlive({ body: kioskId }).pipe(
					map((res) => {
						if (res == null) throw new Error();

						return keepAliveSuccess();
					}),
					catchError((err) => of(keepAliveFailure({ error: err })))
				)
			)
		);
	});

	public loadSysparams$ = createEffect(() => {
		return this.actions$.pipe(
			ofType(loadSysparams),
			switchMap(() =>
				this.sysParamService.sysParamGetAsDto({ Name: "STOP_PROCESS_INTERVAL", DefaultValue: "120", ApplicationType: 'H' }).pipe(
					map((stopProcessInterval) => {
						this.store.dispatch(setStopProcessInterval({ data: parseInt(stopProcessInterval?.value) }));
					}),
					switchMap(() =>
						this.sysParamService.sysParamGetAsDto({ Name: "CARD_ID_MAX_ATTEMPT", DefaultValue: "3", ApplicationType: 'H' }).pipe(
							map((cardIdMaxAttempt) => {
								this.store.dispatch(setCardIdMaxAttempt({ data: parseInt(cardIdMaxAttempt?.value) }));
							})
						)
					),
					switchMap(() =>
						this.sysParamService.sysParamGetAsDto({ Name: "NB_SEND_MAIL_MEDICAL_FORM", DefaultValue: "2" }).pipe(
							map((nb) => {
								this.store.dispatch(setMaxNbSendMailMedicalForm({ data: parseInt(nb?.value) }));
							})
						)
					),
					switchMap(() =>
						this.sysParamService.sysParamGetAsDto({ Name: "HOME_S4_ADD_CHECKSUM", DefaultValue: "False", ApplicationType: 'H' }).pipe(
							map((homeS4AddChecksum) => {
								this.store.dispatch(setHomeS4AddChecksum({ data: homeS4AddChecksum?.value.toUpperCase() == "TRUE" }));
							})
						)
					),
					switchMap(() =>
						this.sysParamService.sysParamGetAsDto({ Name: "PRINT_LIGHT_ENABLED", DefaultValue: "True", ApplicationType: 'H' }).pipe(
							map((printLightEnabled) => {
								this.store.dispatch(setPrintLightEnabled({ data: printLightEnabled?.value.toUpperCase() == "TRUE" }));
								return loadSysparamsSuccess();
							})
						)
					)
				)
			),
			catchError((error) => of(loadSysparamsFailure({ error: error })))
		);
	});
}
